import { observer } from "mobx-react-lite";
import {
  MDSModalDialog,
  MDSDialogHeaderContent,
  MDSDialogTextContent,
  MDSDialogSlotName,
} from "@/mds/components/overlays/dialog";
import { MDSButton, MDSButtonVariant } from "@/mds/components/buttons/button";
import { MDSText, MDSTextVariant, MDSTextWeight, MDSTextColor } from "@/mds/components/text";
import { MDSButtonGroup } from "@/mds/components/buttons/button-group";
import ConnectCalendarLaterGif from "@/assets/images/calendar/connect-calendar-later.gif";
import { useAppStore } from "@/store";
import { trackEvent } from "@/domains/metrics/segment";
import { TrackedEvent } from "@/domains/metrics/tracked-event";

interface NotesListPageConnectCalendarLaterModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const NotesListPageConnectCalendarLaterModal = observer(
  ({ isOpen, handleClose }: NotesListPageConnectCalendarLaterModalProps) => {
    const { store } = useAppStore();

    const handleConfirm = async () => {
      await store.spaceAccountSettings.updateSettingsUsingSyncOperation({
        calendar: {
          hide_calendar_integration_shill: true,
        },
      });
      trackEvent(TrackedEvent.CalendarIntegrationShillHide, {});
      handleClose();
    };

    return (
      <MDSModalDialog isOpen={isOpen} handleClose={handleClose}>
        <MDSDialogHeaderContent slot={MDSDialogSlotName.Header}>
          <MDSText
            variant={MDSTextVariant.HeaderL}
            weight={MDSTextWeight.SemiBold}
            color={MDSTextColor.Contrast}
          >
            Connect your calendar later
          </MDSText>
        </MDSDialogHeaderContent>

        <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
          <MDSText variant={MDSTextVariant.ParagraphS}>
            You can enable the calendar integration later from the integrations page.
          </MDSText>
          <img
            src={ConnectCalendarLaterGif}
            alt="Connect calendar later demonstration"
            style={{ maxHeight: "360px", width: "auto", borderRadius: "8px", marginTop: "8px" }}
          />
        </MDSDialogTextContent>

        <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
          <MDSButton variant={MDSButtonVariant.Contrast} onPress={handleConfirm}>
            Got it
          </MDSButton>
        </MDSButtonGroup>
      </MDSModalDialog>
    );
  }
);
